import { Box, Button, Heading, HStack, Text, useToast, VStack, Divider, Input as ChakraInput, Collapse } from '@chakra-ui/react';
import { Form, Formik } from 'formik';
import { useEffect } from 'react';
import { useState } from 'react';
import * as Yup from 'yup';
import BottomNavBar from '../../../BottomNavBar';
import Select from '../../../SelectField';
import SelectSearch from '../../../SelectFieldSearch2';
import Input from '../../../TextField';
import validaCPF from '../../../Utils/Functions/validaCPF';
import requestTimeout from '../../../Utils/Functions/requestTimeout';
import Loading from '../../../Loading';
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import { AccountContext } from '../../../AccountContext';
import ChildHeader from '../ChildHeader';
import { api } from 'api/api';

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

const FormDadosBancarios = () => {
  const { user, setPage, setUser } = useContext(AccountContext);
  let pixKeyTypes;
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [documentType, setDocumentType] = useState('CPF');
  const documentMask = documentType === 'CPF' ? '999.999.999-99' : '99.999.999/9999-99';
  const [bankData, setBankData] = useState(false);
  const [errorText, setErrorText] = useState('');
  const [syncing, setSyncing] = useState(false);
  const [syncError, setSyncError] = useState('');
  const [showVindiLink, setShowVindiLink] = useState(false);
  const [vindiIdInput, setVindiIdInput] = useState('');
  const [vindiLinking, setVindiLinking] = useState(false);
  const [vindiLinkError, setVindiLinkError] = useState('');
  const [vindiLinkSuccess, setVindiLinkSuccess] = useState(false);
  const [linkedVindiId, setLinkedVindiId] = useState(null);

  setPage('Dados Bancários');

  const [banks, setBanks] = useState([{}]);
  const listbanks = banks.map((bank) => bank.nome);
  const bankAccountTypesPagarme = ['conta_corrente', 'conta_poupanca', 'conta_corrente_conjunta', 'conta_poupanca_conjunta'];
  const bankAccountTypes = ['Conta corrente', 'Conta poupanca', 'Conta corrente conjunta', 'Conta poupanca conjunta'];

  if (documentType === 'CPF') {
    pixKeyTypes = ['CPF', 'E-mail', 'Telefone', 'Aleatória'];
  } else {
    pixKeyTypes = ['CNPJ', 'E-mail', 'Telefone', 'Aleatória'];
  }
  const [pixType, setPixType] = useState(null);

  // Campos de endereço/contato que podem estar faltando no perfil
  const emailRegex = /^[^\s@]+@[^\s@]+\.(?:com|com\.br|br|net)$/i;
  const needsCep = !user.cep;
  const needsLogradouro = !user.logradouro;
  const needsBairro = !user.bairro;
  const needsNumero = !user.numero;
  const needsTelefone = !user.phone1 && !user.phone2;
  const needsEmail = !user.email || !emailRegex.test(user.email);

  const defaultArgs = { borderRadius: 8, w: '100%', maskChar: null };
  const defaultArgsSelect = { textAlign: 'left', fontWeight: 'normal', variant: 'outline', onChange: () => {} };
  const timeOutInSeconds = process.env.REACT_APP_REQUEST_TIMEOUT_IN_SECONDS;
  const navigate = useNavigate();
  const toast = useToast();

  let initialValues = {
    nome: documentType === 'CPF' ? (user.name ? user.name.split(' ')[0] : '') : '',
    documento: documentType === 'CPF' ? user.cpf : '',
    agencia: '',
    digitoAgencia: '',
    conta: '',
    digitoConta: '',
    chavePix: '',
    cep: user.cep || '',
    logradouro: user.logradouro || '',
    bairro: user.bairro || '',
    numero: user.numero || '',
    telefone: user.phone1 || user.phone2 || '',
    email: '',
  };

  function solicitacaoPagarme(payload) {
    setLoading(true);
    const dados = { recipient_id: user.recipient_id, payload: payload };
    api(`${ENDPOINT}/entrepreneur/updateRecipient/`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(dados),
    }).then((res) => {
      setErrorText('');
      if (!res || !res.ok || res.status >= 400) {
        setErrorText('Falha na atualização de dados bancários');
        return;
      }
      res.json().then((data) => {
        if (!data || data.status === false) {
          setErrorText('Falha na atualização de dados bancários');
          return;
        }
        if (data.status === true && data.data) {
          api(`${ENDPOINT}/entrepreneur/updateEmpreendedor/`, {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(dados),
          }).then((res) => {
            setErrorText('');
            if (!res || !res.ok || res.status >= 400) {
              setErrorText('Falha na atualização de dados pessoais');
              return;
            }
            res.json().then((data) => {
              if (!data || data.status === false) {
                setErrorText('Falha na atualização de dados pessoais');
                return;
              }
              if (data.status === true && data.data) {
                navigate('/alerts/sucesso/att_empreendedor');
              }
            });
          });
        }
      });
    });
  }

  if (bankData) {
    const banco = banks.find((bank) => bank.banco_id === bankData.banco_id);
    const banco_index = banks.indexOf(banco);
    initialValues = {
      nome: bankData.titular,
      documento: bankData.documento,
      agencia: bankData.agencia,
      conta: bankData.conta,
      digitoConta: bankData.digito_conta,
      banco: banco_index,
      tipoConta: bankAccountTypesPagarme.indexOf(bankData.tipo_conta),
      tipoPix: pixKeyTypes.indexOf(bankData.tipo_chave_pix),
      chavePix: bankData.chave_pix,
      cep: user.cep || '',
      logradouro: user.logradouro || '',
      bairro: user.bairro || '',
      numero: user.numero || '',
      telefone: user.phone1 || user.phone2 || '',
    };
  }

  const validationSchema = Yup.object({
    nome: Yup.string().required('Campo obrigatório'),
    documento:
      documentType === 'CPF'
        ? Yup.string()
            .required('Campo obrigatório')
            .trim()
            .test('valida_cpf', 'Cpf inválido', (cpf) => validaCPF(cpf))
        : Yup.string()
            .required('Campo obrigatório')
            .trim()
            .matches(/(^\d{2}\.\d{3}\.\d{3}\/\d{4}\-\d{2}$)/, 'CNPJ inválido'),
    banco: Yup.number().required('Campo obrigatório'),
    agencia: Yup.string().required('Campo obrigatório'),
    digitoAgencia: Yup.string(),
    conta: Yup.string().required('Campo obrigatório'),
    digitoConta: Yup.string().required('Campo obrigatório'),
    tipoConta: Yup.number().required('Campo obrigatório'),
    tipoPix: Yup.number().required('Campo obrigatório'),
    chavePix: validaChavePix(),
    ...(needsCep ? { cep: Yup.string().required('CEP obrigatório').matches(/^\d{5}-?\d{3}$/, 'CEP inválido') } : {}),
    ...(needsLogradouro ? { logradouro: Yup.string().required('Logradouro obrigatório') } : {}),
    ...(needsBairro ? { bairro: Yup.string().required('Bairro obrigatório') } : {}),
    ...(needsTelefone ? { telefone: Yup.string().required('Telefone obrigatório').matches(/^\(?\d{2}\)?\s?\d{4,5}-?\d{4}$/, 'Telefone inválido') } : {}),
    ...(needsEmail ? { email: Yup.string().required('E-mail obrigatório').email('E-mail inválido') } : {}),
  });

  let pixInputType;
  let pixInputMask;
  switch (pixType) {
    case 'CPF':
      pixInputType = 'tel';
      pixInputMask = '999.999.999-99';
      break;
    case 'CNPJ':
      pixInputType = 'tel';
      pixInputMask = '99.999.999/9999-99';
      break;
    case 'E-mail':
      pixInputType = 'email';
      pixInputMask = '';
      break;
    case 'Telefone':
      pixInputType = 'tel';
      pixInputMask = '(99) 99999-9999';
      break;
    default:
      pixInputType = 'text';
      pixInputMask = '';
      break;
  }

  const onlyNumbers = (str) => str.replace(/[^0-9]/g, '');

  async function postBankData(payload) {
    const url = ENDPOINT + '/entrepreneur/bank-data';
    const responseRequest = await fetchDatas(url, 'post', payload);
    if (responseRequest.success) {
      setUser((prevState) => ({ ...prevState, recipient_id: responseRequest.data ? responseRequest.data.recipient_id_vindi : null }));
      navigate('/alerts/sucesso/dados_bancarios_empreendedor');
    } else {
      const erros = responseRequest?.data?.errors;
      const msg = Array.isArray(erros) && erros.length > 0
        ? erros.map((e) => (typeof e === 'string' ? e : e.message)).join(', ')
        : responseRequest?.data?.message || 'Erro ao cadastrar conta bancária. Tente novamente.';
      setErrorText(msg);
    }
  }

  async function handleVindiLink() {
    const id = Number(vindiIdInput);
    if (!id || isNaN(id) || id <= 0) {
      setVindiLinkError('Informe um código de vendedor válido (somente números).');
      return;
    }
    setVindiLinking(true);
    setVindiLinkError('');
    setVindiLinkSuccess(false);

    const token = localStorage.getItem('token');
    let res = null;
    try {
      const httpResponse = await fetch(ENDPOINT + '/entrepreneur/vincular-vindi', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', authorization: token || '' },
        body: JSON.stringify({ empreendedor_id: user.id_empreendedor, vindi_affiliate_id: id }),
      });
      res = await httpResponse.json();
    } catch {
      setVindiLinkError('Erro de conexão. Tente novamente.');
      setVindiLinking(false);
      return;
    }

    if (res?.success && res?.needs_bank_data) {
      setLinkedVindiId(res.vindi_affiliate_id);
      setVindiLinkSuccess(true);
      setShowVindiLink(false);
    } else if (res?.success) {
      setVindiLinkSuccess(true);
      toast({
        title: 'Código vinculado com sucesso!',
        description: 'Seus dados foram sincronizados com a Vindi.',
        status: 'success',
        duration: 4000,
        isClosable: true,
      });
      await getDatas();
    } else {
      setVindiLinkError(res?.message || 'Não foi possível vincular o código. Verifique e tente novamente.');
    }
    setVindiLinking(false);
  }

  async function syncBankFromVindi() {
    setSyncing(true);
    setSyncError('');
    try {
      const res = await fetchDatas(ENDPOINT + '/entrepreneur/sync-bank-from-vindi', 'post', {
        empreendedor_id: user.id_empreendedor,
      });
      if (res?.success && res?.updated) {
        toast({ title: 'Dados sincronizados com sucesso!', status: 'success', duration: 3000, isClosable: true });
        await getDatas();
      } else if (res?.success && !res?.updated) {
        setSyncError(res?.message || 'Nenhum dado bancário atualizado encontrado na Vindi.');
      } else {
        setSyncError('Não foi possível sincronizar. Verifique se os dados foram atualizados na Vindi e tente novamente.');
      }
    } catch {
      setSyncError('Erro de conexão. Tente novamente.');
    }
    setSyncing(false);
  }

  async function onSubmit(values, dados) {
    //setLoading(true);
    const payload = {
      empreendedor_id: user.id_empreendedor,
      banco_id: banks[values.banco].banco_id,
      tipo_chave_pix: pixKeyTypes[values.tipoPix],
      chave_pix: values.chavePix,
      ...(linkedVindiId ? { vindi_affiliate_id: linkedVindiId } : {}),
      address_extra: {
        cep: onlyNumbers(values.cep),
        logradouro: values.logradouro,
        bairro: values.bairro,
        numero: values.numero || 'S/N',
        telefone: onlyNumbers(values.telefone),
        email: values.email || user.email || '',
      },
      bank_account: {
        bank_code: banks[values.banco].codigo,
        agencia: values.agencia,
        //agencia_dv: values.digitoAgencia,
        conta: values.conta,
        conta_dv: values.digitoConta,
        type: bankAccountTypesPagarme[values.tipoConta],
        document_type: documentType.toLowerCase(),
        document_number: onlyNumbers(values.documento),
        legal_name: values.nome,
      },
    };
    console.log(payload);
    if (bankData?.recipient_id_vindi) {
      solicitacaoPagarme(payload);
    } else {
      postBankData(payload);
    }
  }

  function validaChavePix() {
    switch (pixType) {
      case 'CPF':
        return Yup.string()
          .required('Campo obrigatório')
          .trim()
          .test('valida_cpf', 'Cpf inválido', (cpf) => validaCPF(cpf));
      case 'E-mail':
        return Yup.string().trim().email('O email digitado é inválido').required('Campo obrigatório');
      case 'Telefone':
        return Yup.string()
          .required('Campo obrigatório')
          .trim()
          .matches(/^\(?[1-9]{2}\)? ?(?:[2-8]|9[1-9])[0-9]{3}\-?[0-9]{4}$/, 'Telefone Inválido');
      default:
        return Yup.string().required('Campo obrigatório');
    }
  }

  async function fetchDatas(url, verb, payload) {
    let options;
    if (verb === 'get') {
      options = {
        signal: requestTimeout(timeOutInSeconds).signal,
        method: 'GET',
      };
    } else if (verb === 'post') {
      options = {
        signal: requestTimeout(timeOutInSeconds).signal,
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      };
    }
    try {
      const respondeData = await api(url, options);
      return await respondeData.json();
    } catch (error) {
      setError(true);
      setLoading(false);
      console.log(error);
    }
  }

  async function getDatas() {
    const urlBanks = ENDPOINT + '/banks/';
    const urlBankData = ENDPOINT + '/entrepreneur/bank-data/' + user.id_empreendedor;
    const requestBanks = await fetchDatas(urlBanks);
    const requestBankData = await fetchDatas(urlBankData);
    if (requestBanks.success && requestBankData.success) {
      requestBankData.data && setDocumentType(requestBankData.data.tipo_documento.toUpperCase());
      setBanks(requestBanks.data);
      setBankData(requestBankData.data);
    } else {
      setError(true);
    }
    setLoading(false);
  }

  useEffect(() => {
    getDatas();
  }, []);

  if (loading) return <Loading />;
  if (error) return navigate('/alerts/erro/default');

  if (bankData && bankData.recipient_id_vindi) {
    const bancoNome = banks.find((b) => b.banco_id === bankData.banco_id)?.nome ?? 'Não informado';
    const tipoContaLabel = {
      conta_corrente: 'Conta Corrente',
      conta_poupanca: 'Conta Poupança',
      conta_corrente_conjunta: 'Conta Corrente Conjunta',
      conta_poupanca_conjunta: 'Conta Poupança Conjunta',
    }[bankData.tipo_conta] ?? bankData.tipo_conta;

    return (
      <VStack w={{ base: '90%', md: '500px' }} align="start" mx="auto" mt="5" mb="20" spacing={5}>
        <Heading size="md">Dados bancários cadastrados</Heading>

        <Box bg="gray.50" border="1px solid" borderColor="gray.200" borderRadius="8" p="4" w="100%" spacing={2}>
          <VStack align="start" spacing={1}>
            <Text fontSize="sm" color="gray.500">Titular</Text>
            <Text fontWeight="semibold">{bankData.titular}</Text>
          </VStack>
          <Divider my="3" />
          <VStack align="start" spacing={1}>
            <Text fontSize="sm" color="gray.500">Banco</Text>
            <Text fontWeight="semibold">{bancoNome}</Text>
          </VStack>
          <Divider my="3" />
          <HStack w="100%" align="start" spacing={6}>
            <VStack align="start" spacing={1}>
              <Text fontSize="sm" color="gray.500">Agência</Text>
              <Text fontWeight="semibold">{bankData.agencia}</Text>
            </VStack>
            <VStack align="start" spacing={1}>
              <Text fontSize="sm" color="gray.500">Conta</Text>
              <Text fontWeight="semibold">{bankData.conta}-{bankData.digito_conta}</Text>
            </VStack>
          </HStack>
          <Divider my="3" />
          <VStack align="start" spacing={1}>
            <Text fontSize="sm" color="gray.500">Tipo de conta</Text>
            <Text fontWeight="semibold">{tipoContaLabel}</Text>
          </VStack>
        </Box>

        <Box bg="yellow.50" border="1px solid" borderColor="yellow.300" borderRadius="8" p="4" w="100%">
          <Text fontSize="sm" color="yellow.800" fontWeight="semibold" mb="2">
            Como atualizar seus dados bancários
          </Text>
          <Text fontSize="sm" color="yellow.700" mb="2">
            Os dados bancários são gerenciados pela <strong>Vindi (Yapay)</strong>, nossa plataforma parceira de pagamentos.
            Para atualizá-los:
          </Text>
          <Text fontSize="sm" color="yellow.700" mb="1">
            1. Acesse{' '}
            <Text as="a" href="https://signin.yapay.com.br/login/intermediador" target="_blank" rel="noreferrer" color="blue.600" textDecoration="underline" fontWeight="semibold">
              signin.yapay.com.br
            </Text>
            {' '}com o e-mail e senha cadastrados na Vindi.
          </Text>
          <Text fontSize="sm" color="yellow.700" mb="1">
            2. Atualize seus dados bancários por lá.
          </Text>
          <Text fontSize="sm" color="yellow.700">
            3. Volte aqui e clique em <strong>"Solicitar portabilidade"</strong> para sincronizar os dados com o app.
          </Text>
        </Box>

        {syncError && (
          <Text color="red.500" fontSize="sm" w="100%">{syncError}</Text>
        )}

        <Button
          w="100%"
          backgroundColor="#5AB2AE"
          color="#FFF"
          borderRadius="8"
          onClick={syncBankFromVindi}
          isLoading={syncing}
          loadingText="Sincronizando..."
          disabled={syncing}
        >
          Solicitar portabilidade
        </Button>
      </VStack>
    );
  }

  return (
    <Formik
      initialValues={initialValues}
      validateOnChange={false}
      validateOnBlur={false}
      validationSchema={validationSchema}
      onSubmit={(values, actions) => {
        onSubmit(values, bankData);
      }}
    >
      <VStack as={Form} w={{ base: '90%', md: '500px' }} align="start" mx="auto" mt="5" mb="20" spacing={5}>
        <Heading size="md">Informe os dados bancários para o recebimento de seus serviços</Heading>

        {bankData && !bankData.recipient_id_vindi && (
          <Box bg="orange.50" border="1px solid" borderColor="orange.300" borderRadius="8" p="3" w="100%">
            <Text fontSize="sm" color="orange.800" fontWeight="semibold" mb="1">
              Recadastro necessário
            </Text>
            <Text fontSize="sm" color="orange.700">
              Seus dados bancários precisam ser cadastrados no novo sistema de pagamentos (Vindi).
              Os campos já foram preenchidos com os dados anteriores — revise e confirme para concluir.
            </Text>
          </Box>
        )}

        <Box bg="blue.50" border="1px solid" borderColor="blue.200" borderRadius="8" p="3" w="100%">
          <Text fontSize="sm" color="blue.800" fontWeight="semibold" mb="1">
            Cadastro processado pela Vindi
          </Text>
          <Text fontSize="sm" color="blue.700">
            Seus dados serão enviados à <strong>Vindi</strong>, nossa plataforma parceira de pagamentos.
            Se precisar enviar documentos para verificação, você receberá um <strong>e-mail da Vindi</strong> com um link de acesso à plataforma deles.
          </Text>
          <Text fontSize="sm" color="blue.700" mt="1">
            Seu login na Vindi será o seu <strong>e-mail cadastrado</strong> e a senha inicial será o número do seu CPF ou CNPJ.
          </Text>
        </Box>

        <Box w="100%">
          <Text
            fontSize="sm"
            color="blue.600"
            fontWeight="semibold"
            cursor="pointer"
            onClick={() => { setShowVindiLink(!showVindiLink); setVindiLinkError(''); setVindiLinkSuccess(false); }}
            _hover={{ textDecoration: 'underline' }}
          >
            {showVindiLink ? '▲ Ocultar' : '▼ Já possui cadastro na Vindi? Informe seu código de vendedor'}
          </Text>

          <Collapse in={showVindiLink} animateOpacity>
            <VStack mt="3" spacing="3" align="start">
              <Text fontSize="xs" color="gray.600">
                Se você já tem uma conta ativa na plataforma{' '}
                <Text as="a" href="https://signin.yapay.com.br/login/intermediador" target="_blank" rel="noreferrer" color="blue.500" textDecoration="underline">
                  Vindi (Yapay)
                </Text>
                , informe o código do seu afiliado para vincular automaticamente sem precisar preencher os dados bancários novamente.
              </Text>

              {vindiLinkSuccess ? (
                <Box bg="green.50" border="1px solid" borderColor="green.300" borderRadius="8" p="3" w="100%">
                  <Text fontSize="sm" color="green.700" fontWeight="semibold">
                    ✓ Conta vinculada com sucesso! Os dados estão sendo carregados...
                  </Text>
                </Box>
              ) : (
                <>
                  <HStack w="100%" spacing="2">
                    <ChakraInput
                      value={vindiIdInput}
                      onChange={(e) => { setVindiIdInput(e.target.value); setVindiLinkError(''); }}
                      placeholder="Código do vendedor (ex: 12345)"
                      type="number"
                      borderRadius="8"
                      flex="1"
                      size="md"
                      min="1"
                    />
                    <Button
                      onClick={handleVindiLink}
                      isLoading={vindiLinking}
                      loadingText="Verificando..."
                      backgroundColor="#5AB2AE"
                      color="#FFF"
                      borderRadius="8"
                      size="md"
                      px="5"
                      flexShrink={0}
                      disabled={!vindiIdInput || vindiLinking}
                    >
                      Vincular
                    </Button>
                  </HStack>

                  {vindiLinkError && (
                    <Text color="red.500" fontSize="sm">{vindiLinkError}</Text>
                  )}
                </>
              )}
            </VStack>
          </Collapse>
        </Box>

        {linkedVindiId && (
          <Box bg="green.50" border="1px solid" borderColor="green.300" borderRadius="8" p="3" w="100%">
            <Text fontSize="sm" color="green.700" fontWeight="semibold">
              ✓ Código Vindi #{linkedVindiId} verificado! Preencha seus dados bancários abaixo para concluir o vínculo.
            </Text>
          </Box>
        )}

        <Divider />

        <Input
          {...defaultArgs}
          name="nome"
          placeholder={documentType === 'CPF' ? 'Primeiro Nome' : 'Razão Social'}
          type="text"
          mask=""
          maxlength="20"
          style={{ textTransform: 'capitalize' }}
        />
        <Input {...defaultArgs} name="documento" placeholder={documentType} type="tel" mask={documentMask} disabled />
        {needsCep && <Input {...defaultArgs} name="cep" placeholder="CEP" type="tel" mask="99999-999" />}
        {needsLogradouro && <Input {...defaultArgs} name="logradouro" placeholder="Logradouro (rua/avenida)" type="text" mask="" />}
        {needsNumero && <Input {...defaultArgs} name="numero" placeholder="Número" type="text" mask="" />}
        {needsBairro && <Input {...defaultArgs} name="bairro" placeholder="Bairro" type="text" mask="" />}
        {needsTelefone && <Input {...defaultArgs} name="telefone" placeholder="Telefone celular" type="tel" mask="(99) 99999-9999" />}
        {needsEmail && <Input {...defaultArgs} name="email" placeholder="Seu e-mail (receberá o acesso à Vindi)" type="email" mask="" />}
        <SelectSearch {...defaultArgs} {...defaultArgsSelect} name="banco" placeholder="Selecione o banco" options={listbanks} />
        <HStack w="100%" align="start">
          <Input {...defaultArgs} w="50%" name="agencia" placeholder="Agência" type="tel" mask="9999" />
        </HStack>
        <HStack w="100%" align="start">
          <Input {...defaultArgs} name="conta" placeholder="Conta" type="tel" mask="999999999999" />
          <Input {...defaultArgs} name="digitoConta" placeholder="Dígito" type="tel" mask="9" />
        </HStack>
        <Select {...defaultArgs} {...defaultArgsSelect} name="tipoConta" placeholder="Selecione o tipo de conta" options={bankAccountTypes} />
        <Select
          {...defaultArgs}
          {...defaultArgsSelect}
          name="tipoPix"
          placeholder="Selecione o tipo de chave pix"
          options={pixKeyTypes}
          onChange={(index) => setPixType(pixKeyTypes[index])}
        />
        <Input {...defaultArgs} name="chavePix" placeholder="Chave pix" type={pixInputType} mask={pixInputMask} />

        {errorText && (
          <Text color="red.500" fontSize="sm" w="100%">{errorText}</Text>
        )}

        <Button {...defaultArgs} backgroundColor="#5AB2AE" color="#FFF" type="submit">
          Salvar
        </Button>
      </VStack>
    </Formik>
  );
};

const DadosBancarios = () => {
  return (
    <>
      <ChildHeader />
      <FormDadosBancarios />
      <BottomNavBar />
    </>
  );
};

export default DadosBancarios;
